"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const utils_1 = require("core/utils");
const app_1 = require("ducks/app");
const households_1 = require("ducks/households");
const user_1 = require("ducks/user");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const user_2 = require("selectors/user");
const useExperiments_1 = require("src/hooks/useExperiments");
const login_error_1 = __importDefault(require("./login-error"));
const container_1 = __importDefault(require("./orders/container"));
const container_2 = __importDefault(require("./settings/container"));
const invitation_1 = __importDefault(require("./v1/invitation"));
const signup_1 = __importDefault(require("./v1/signup"));
const team_1 = __importDefault(require("./v1/team"));
const user_3 = __importDefault(require("./v1/user"));
const AuthRoute = ({ component: Component, userOnly, returnForSignup, ...rest }) => {
    const isUserLoaded = (0, react_redux_1.useSelector)(user_2.userLoaded);
    const dispatch = (0, react_redux_1.useDispatch)();
    React.useEffect(() => {
        if (userOnly) {
            dispatch((0, user_1.loadUser)(returnForSignup));
        }
        else {
            dispatch((0, user_1.getUserAndMembersAndTeamsAndProfileAndContactInfosAndHouseholds)());
        }
        const token = (0, utils_1.getParameterByName)(window.location.href, 'token');
        const type = (0, utils_1.getParameterByName)(window.location.href, 'type');
        if (token && type === 'householdInvite') {
            dispatch((0, households_1.acceptHouseholdInviteToken)(token));
        }
    }, []);
    return (React.createElement(react_router_dom_1.Route, { ...rest, render: (props) => {
            if (isUserLoaded) {
                if (Component) {
                    return React.createElement(Component, { ...props });
                }
                if (rest.render) {
                    return rest.render(props);
                }
            }
            return (
            // @ts-ignore
            React.createElement(teamsnap_ui_1.Loader, { style: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                } }));
        } }));
};
const Root = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const checkConnectionHandler = () => dispatch((0, app_1.checkConnectionStatusContinually)());
    React.useEffect(() => {
        // displays warning toast if user is offline
        checkConnectionHandler();
        window.addEventListener('online', checkConnectionHandler);
        window.addEventListener('offline', checkConnectionHandler);
        return () => {
            window.removeEventListener('online', checkConnectionHandler);
            window.removeEventListener('offline', checkConnectionHandler);
        };
    }, []);
    return (React.createElement(react_router_dom_1.BrowserRouter, { basename: "/" },
        React.createElement(useExperiments_1.ExperimentProvider, null,
            React.createElement(snap_ui_1.ToastProvider, null),
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { path: "/signup", component: signup_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "/invitations/:invitationCode", component: invitation_1.default }),
                React.createElement(AuthRoute, { path: "/team", component: team_1.default, userOnly: true, returnForSignup: true }),
                React.createElement(AuthRoute, { path: "/user", component: user_3.default, userOnly: true }),
                React.createElement(AuthRoute, { exact: true, path: "/", render: () => React.createElement(react_router_1.Redirect, { to: "/settings" }) }),
                React.createElement(AuthRoute, { path: "/settings", component: container_2.default }),
                React.createElement(AuthRoute, { path: "/orders", component: container_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "/login-error", component: login_error_1.default })))));
};
exports.default = Root;
